import { Lock } from 'lucide-react'

export function NotDownloadableViewer() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-muted/30 p-6">
      <div className="flex max-w-md flex-col items-center gap-6 rounded-xl border border-border bg-background p-8 text-center shadow-sm">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
          <Lock className="size-8 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">Download Not Permitted</h3>
          <p className="text-sm text-muted-foreground">The instructor has restricted downloading of this resource.</p>
        </div>
      </div>
    </div>
  )
}
